/** What the Types page shows and what each type allows (deliverable 4). */
import type { DocTypeV1 } from '@codex/contracts';
import { TYPE_KEYS, type TypeKey } from '@codex/ui';

/** The glyphs and hues a type may take: the kit's, which are also the server's accepted list. */
export const LOOKS: readonly TypeKey[] = TYPE_KEYS;

export const isLook = (value: string): value is TypeKey =>
  (LOOKS as readonly string[]).includes(value);

export interface TypeGroups {
  readonly canon: DocTypeV1[];
  readonly reference: DocTypeV1[];
  readonly archived: DocTypeV1[];
}

/** Live canon types in answer order; reference types only with the flag; archived types apart. */
export function groupTypes(
  types: readonly DocTypeV1[],
  options: { reference: boolean },
): TypeGroups {
  return {
    canon: types.filter((type) => type.library === 'canon' && !type.archived),
    reference: options.reference ? types.filter((type) => type.library === 'reference') : [],
    archived: types.filter((type) => type.library === 'canon' && type.archived),
  };
}

export interface EditRules {
  readonly readOnly: boolean;
  readonly canArchive: boolean;
  readonly canRestore: boolean;
  readonly capabilitiesLocked: boolean;
}

export function editRules(type: DocTypeV1): EditRules {
  const readOnly = type.library === 'reference';
  const user = !readOnly && !type.builtin;
  return {
    readOnly,
    canArchive: user && !type.archived,
    canRestore: user && type.archived,
    capabilitiesLocked: type.key === 'session',
  };
}
